import {
  FETCH_INSPECTIONS,
  FETCH_INSPECTIONS_SUCCESS,
  FETCH_INSPECTION,
  FETCH_INSPECTION_SUCCESS,
  UPDATE_INSPECTION,
  UPDATE_INSPECTION_SUCCESS,
  FETCH_WAREHOUSE_OPTIONS,
  FETCH_WAREHOUSE_OPTIONS_SUCCESS,
  FETCH_CONSIGNER_OPTIONS, FETCH_CONSIGNER_OPTIONS_SUCCESS,
  FETCH_WAREHOUSER_OPTIONS, FETCH_WAREHOUSER_OPTIONS_SUCCESS,
  FETCH_WAREHOUSER_WAREHOUSE_OPTIONS, FETCH_WAREHOUSER_WAREHOUSE_OPTIONS_SUCCESS,
  FETCH_CONSIGNER_PRODUCT, FETCH_CONSIGNER_PRODUCT_SUCCESS,
  SEARCH_CONSIGNER_PRODUCTS, SEARCH_CONSIGNER_PRODUCTS_SUCCESS,
  ON_SHOW_LOADER, ON_HIDE_LOADER, SAVE_ITEM, SAVE_ITEM_SUCCESS, NEW_SAVE_ITEM
} from "../constants/ActionTypes";

export const fetchInspections = (params) => {
  return {
    type: FETCH_INSPECTIONS,
    payload: params
  };
};
export const fetchInspectionsSuccess = entities => {
  return {
    type: FETCH_INSPECTIONS_SUCCESS,
    payload: entities
  };
};
export const fetchWarehouseOptions = () => {
  return {
    type: FETCH_WAREHOUSE_OPTIONS
  };
};
export const fetchWarehouseOptionsSuccess = entities => {
  return {
    type: FETCH_WAREHOUSE_OPTIONS_SUCCESS,
    payload: entities
  };
};
export const fetchInspection = (id) => {
  return {
    type: FETCH_INSPECTION,
    payload: id
  };
};
export const fetchInspectionSuccess = inspection => {
  return {
    type: FETCH_INSPECTION_SUCCESS,
    payload: inspection
  };
};
export const updateInspection = (inspection) => {
  return {
    type: UPDATE_INSPECTION,
    payload: inspection
  };
};
export const updateInspectionSuccess = inspection => {
  return {
    type: UPDATE_INSPECTION_SUCCESS,
    payload: inspection
  };
};
export const fetchConsignerOptions = () => {
  return {
    type: FETCH_CONSIGNER_OPTIONS
  };
};
export const fetchConsignerOptionsSuccess = entities => {
  return {
    type: FETCH_CONSIGNER_OPTIONS_SUCCESS,
    payload: entities
  };
};

export const fetchConsignerProduct = (params) => {
  return {
    type: FETCH_CONSIGNER_PRODUCT,
    payload: params
  };
};
export const fetchConsignerProductSuccess = (params) => {
  return {
    type: FETCH_CONSIGNER_PRODUCT_SUCCESS,
    payload: params
  };
};

export const searchConsignerProducts = (params) => {
  return {
    type: SEARCH_CONSIGNER_PRODUCTS,
    payload: params
  };
};
export const searchConsignerProductsSuccess = entities => {
  return {
    type: SEARCH_CONSIGNER_PRODUCTS_SUCCESS,
    payload: entities
  };
};

export const fetchWarehouserOptions = () => {
  return {
    type: FETCH_WAREHOUSER_OPTIONS
  };
};
export const fetchWarehouserOptionsSuccess = entities => {
  return {
    type: FETCH_WAREHOUSER_OPTIONS_SUCCESS,
    payload: entities
  };
};

export const fetchWarehousesForWarehouserOptions = (params) => {
  return {
    type: FETCH_WAREHOUSER_WAREHOUSE_OPTIONS,
    payload: params
  };
};
export const fetchWarehousesForWarehouserOptionsSuccess = entities => {
  return {
    type: FETCH_WAREHOUSER_WAREHOUSE_OPTIONS_SUCCESS,
    payload: entities
  };
};

export const saveItem = (data) => {
  return {
    type: SAVE_ITEM,
    payload: data
  };
};
export const saveItemSuccess = data => {
  return {
    type: SAVE_ITEM_SUCCESS,
    payload: data
  };
};
export const newSaveItem = () => {
  return {
    type: NEW_SAVE_ITEM
  };
};


export const showLoader = () => {
  return {
      type: ON_SHOW_LOADER,
  };
};
export const hideLoader = () => {
  return {
      type: ON_HIDE_LOADER,
  };
};
